exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".payment-option {\n  margin-bottom: 0.5rem;\n  margin-right: 1rem;\n  display: block; }\n  .payment-option-list {\n    margin-bottom: 1rem; }\n  .payment-option-input {\n    vertical-align: top !important; }\n  .payment-option-input:checked > .payment-option-title {\n    text-decoration: underline; }\n  @media only screen and (min-width: 1000px) {\n    .payment-option {\n      display: inline-block; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["C://Users//T.ETTLING//Desktop//VirGroup Webseiten//src//scss"]}!./src/components/PaymentOptions.scss
// module id = 882
// module chunks = 0